import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollapsiblePanelLightComponent } from './collapsible-panel-light.component';
import { MatIconModule } from '@angular/material/icon';
// import { SharedModule } from '../../shared.module';


@NgModule({
  declarations: [
    CollapsiblePanelLightComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    // SharedModule
  ],
  exports: [CollapsiblePanelLightComponent]
})
export class CollapsiblePanelLightModule { }
